function readFile(file: File): Promise<{ file: File; data: Uint8Array }> {
  return new Promise(function (resolve) {
    const reader = new FileReader()
    reader.onloadend = function () {
      if (reader.readyState != FileReader.DONE) return

      resolve({
        file: file,
        data: new Uint8Array(reader.result as ArrayBuffer),
      })
    }
    reader.readAsArrayBuffer(file)
  })
}

export { readFile }
